import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgHotPriceCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <defs>
      <linearGradient
        id="hot-price-circle_svg__a"
        x1="50%"
        x2="50%"
        y1="100%"
        y2="0%"
      >
        <stop offset="0%" stopColor="#FF860C" />
        <stop offset="100%" stopColor="#E5200E" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle cx={8} cy={8} r={8} fill="url(#hot-price-circle_svg__a)" />
      <path
        fill="#FFF"
        d="M5.183 7.508c-1.166.855-1.529 2.41-.824 3.651.085.152.186.295.298.43l.039.045c.411.466 1.2.997 2.871 1.366l-.672-.808a1.46 1.46 0 0 1 .03-1.659l.028-.037c.285-.371 1.047-.793 1.273-1.204.25-.453.297-1.216.24-1.47 1.814 1.232 2.098 3.202 1.053 5.176 6.55-3.076 1.982-7.616 1.254-8.131.241.514.465 1.18-.025 1.604C9.92 3.421 7.695 3 7.695 3c.08.525.01 1.076-.16 1.621a4.933 4.933 0 0 1-1.8 2.484l-.552.403z"
      />
    </g>
  </svg>
);
const Memo = memo(SvgHotPriceCircle);
export default Memo;
